import $ from '../../../globals/jquery';

(document => {
  const selector = '.js-demand-capture-form';
  const prelaunch = {
    onDemandCaptureSuccess($hideables, $showables) {
      $hideables.hide();
      $showables.show();
    },

    onDemandCaptureFailure($errorContainer, $errorMessage, response) {
      // Handle any server errors not caught by $.validate
      const errors = response.responseJSON;
      $errorMessage.text(Object.values(errors).join(' '));
      $errorContainer.show();
    },

    handleSubmit() {
      $(document).on('submit', selector, event => {
        event.preventDefault();
        const $target = $(event.currentTarget);
        const $form = $target.closest('form');
        const $errorMessageContainer = $form.find('.js-error-message');
        $errorMessageContainer.hide();
        $form.validate({
          rules: {
            email: { required: true },
            interest_type: { required: true },
          },
        });
        if ($form.valid()) {
          $.post($form.attr('action'), $form.serialize(), 'json')
            .success(
              this.onDemandCaptureSuccess.bind(
                this,
                $form.find('.js-demand-capture-inputs'),
                $form.find('.js-success-message')
              )
            )
            .error(
              this.onDemandCaptureFailure.bind(
                this,
                $errorMessageContainer,
                $form.find('.js-error-message-content')
              )
            );
        }
      });
    },

    init() {
      this.handleSubmit();
    },
  };
  prelaunch.init();
})(document);
